export function mealMoveModeVisibility({ type, moveActive }) {
  const movingMeal = type === 'meal' && moveActive === true;
  return {
    hideHeaderNutrition: movingMeal,
    hideSummary: movingMeal,
    hideActions: movingMeal,
    hidePlanAndSocial: movingMeal,
  };
}
